import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router";
import { displayUser, displayUsers } from "../../utility/utility";

const ProtestsTable = ({ protests }) => {
  const navigation = useNavigate();

  const extractDisplayText = (text) => {
    if (text.length > 42) {
      return text.substr(0, 40) + "..";
    }
    return text;
  };

  const handleRowClick = (protest) => {
    console.log("Clicked protest", protest);
    navigation("/protests/view", { state: protest });
  };

  return (
    <>
      {protests.length > 0 ? (
        <Table variant="striped" colorScheme="gray">
          <Thead>
            <Tr>
              <Th>Id</Th>
              <Th>Protester</Th>
              <Th>Text</Th>
              <Th>Race</Th>
              <Th>Race Time</Th>
              <Th>State</Th>
              <Th>Reported Driver(s)</Th>
            </Tr>
          </Thead>
          <Tbody>
            {protests.map((protest, index) => {
              return (
                <Tr
                  key={protest.protest_id}
                  onClick={() => handleRowClick(protest)}
                >
                  <Td>{protest.protest_id}</Td>
                  <Td>
                    {displayUser(
                      protest.protester,
                      protest.protester_driver_number
                    )}
                  </Td>
                  <Td>{extractDisplayText(protest.protest_text)}</Td>
                  <Td>{protest.race}</Td>
                  <Td>
                    {new Date(protest.protest_time * 1000)
                      .toISOString()
                      .substr(11, 8)}
                  </Td>
                  <Td>{protest.protest_state}</Td>
                  <Td>{displayUsers(protest.reported)}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      ) : (
        <p>No protests available</p>
      )}
    </>
  );
};

export default ProtestsTable;
